/* HC okt 2026: PDP-galerij altijd in de normale fotovolgorde.
   Het theme zet de foto van de gekozen variant vooraan. Dit script (geladen via snippets/hc-copy-fixes.liquid,
   direct na de galerij en vóór de deferred galerij-scripts) zet slides en thumbnails terug in de volgorde van product.media.
   - Met ?variant= in de URL (bijv. vanaf een kleurbolletje op de collectiepagina): start op de foto van die variant
     (is-initial-selected = Flickity initialIndex) en zet de thumbnail-strook er direct naast (instant, geen animatie).
   - Zonder ?variant=: start gewoon op de eerste foto van de reeks. */
(function () {
  var d = window.hcMedia || {}, o = d.o || [];
  var f = /[?&]variant=\d+/.test(location.search) ? d.f : 0;
  var s = document.getElementById('Product-Slider');
  if (!s || o.length < 2) return;
  function srt(b) {
    var m = {};
    [].forEach.call(b.children, function (k) { var r = (k.id || '').match(/-(\d+)$/); if (r) m[r[1]] = k; });
    var l = o.map(function (i) { return m[i]; }).filter(Boolean);
    if (l.length > 1) l.forEach(function (k) { b.appendChild(k); });
  }
  srt(s);
  var t = document.getElementById('Product-Thumbnails');
  if (t) srt(t);
  var a = f && s.querySelector('[data-media-id$="-' + f + '"]');
  if (a) {
    a.classList.add('is-initial-selected');
  } else if (t) {
    [].forEach.call(t.querySelectorAll('.is-initial-selected'), function (el) { el.classList.remove('is-initial-selected'); });
    var first = t.querySelector('.product-thumbnail.is-active') || t.querySelector('.product-thumbnail');
    if (first) first.classList.add('is-initial-selected');
  }
  if (!a) return;
  var userMoved = false;
  if (t) {
    ['wheel', 'touchstart', 'pointerdown'].forEach(function (ev) { t.addEventListener(ev, function () { userMoved = true; }, { passive: true }); });
  }
  function center() {
    if (userMoved) return;
    if (t) {
      var q = t.querySelector('.is-initial-selected');
      if (q && q.previousElementSibling && t.clientHeight) {
        var r = q.getBoundingClientRect(), c = t.getBoundingClientRect();
        t.scrollTo({
          top: t.scrollTop + r.top - c.top - (t.clientHeight - q.clientHeight) / 2,
          left: t.scrollLeft + r.left - c.left - (t.clientWidth - q.clientWidth) / 2,
          behavior: 'instant'
        });
      }
    }
    if (s.tagName !== 'PRODUCT-SLIDER-THUMBNAILS' && a.previousElementSibling) {
      s.scrollTo({ left: a.offsetLeft - s.offsetLeft, behavior: 'instant' });
    }
  }
  center();
  requestAnimationFrame(center);
  document.addEventListener('DOMContentLoaded', center);
  if (document.readyState === 'complete') center(); else window.addEventListener('load', function () { center(); setTimeout(center, 300); });
})();
/* HC 12 okt 2026: soepeler swipen in de PDP-galerij.
   - Flickity settelt sneller (selectedAttraction 0.2 / friction 0.8 i.p.v. de trage standaard 0.025 / 0.28).
   - adaptiveHeight uit als alle foto's dezelfde verhouding hebben: de galerijhoogte springt niet meer mee bij elke foto.
   - Na het laden worden alle galerijfoto's alvast ingeladen (lazysizes unveil), zodat er bij swipen geen lege foto inploft. */
(function () {
  var s = document.getElementById('Product-Slider');
  if (!s) return;
  var tries = 0;
  function tune() {
    var F = window.Flickity, inst = F && F.data ? F.data(s) : null;
    if (!inst) { if (tries++ < 40) setTimeout(tune, 250); return; }
    inst.options.selectedAttraction = 0.2;
    inst.options.friction = 0.8;
    var r = {};
    [].forEach.call(s.querySelectorAll('.product-single__media'), function (m) { r[m.getAttribute('style') || ''] = 1; });
    if (inst.options.adaptiveHeight && Object.keys(r).length === 1) { inst.options.adaptiveHeight = false; if (inst.resize) inst.resize(); }
  }
  function preload() {
    var imgs = s.querySelectorAll('img.lazyload'), i = 0;
    function next() {
      if (i >= imgs.length) return;
      var img = imgs[i++];
      img.decoding = 'async';
      if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.unveil(img); else img.classList.add('lazypreload');
      setTimeout(next, 100);
    }
    next();
  }
  function go() { tune(); (window.requestIdleCallback || function (cb) { setTimeout(cb, 200); })(preload); }
  if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
})();